var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentSieId)?_c('div',[_c('page-header',{attrs:{"has-return":"","page":{
      icon: 'fas fa-user-edit',
      title: 'Historial del PEI',
      routes: ['Inicio', 'Historial del PEI'],
    }}}),_c('student-pei-history',{attrs:{"student-sie-id":_vm.studentSieId}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }